import { DialogContent } from '@mui/material'
import React from 'react'
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogActions,
  StyledButton
} from "./styles";

function AxlDialog({title, content, actions, handleOk, isOpen}) {

  return (
    <StyledDialog open={isOpen} maxWidth={'sm'}>
      <StyledDialogTitle>{title}</StyledDialogTitle>
      <DialogContent>{content}</DialogContent>
      <StyledDialogActions>
        {actions || (<StyledButton onClick={handleOk}>OK</StyledButton>)}
      </StyledDialogActions>
    </StyledDialog>
  )
}

export default AxlDialog